import { render } from "./learnerCentralSideMenu.vue?vue&type=template&id=0cc66ff0&scoped=true"
import script from "./learnerCentralSideMenu.vue?vue&type=script&lang=js"
export * from "./learnerCentralSideMenu.vue?vue&type=script&lang=js"

import "./learnerCentralSideMenu.vue?vue&type=style&index=0&id=0cc66ff0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc66ff0"]])

export default __exports__